import { useState, useEffect, RefObject } from 'react';

interface ContainerSize {
  width: number;
  height: number;
}

export const useContainerSize = (ref: RefObject<HTMLDivElement>): ContainerSize => {
  const [size, setSize] = useState<ContainerSize>({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }
    });

    resizeObserver.observe(ref.current);

    // 初始化尺寸
    const rect = ref.current.getBoundingClientRect();
    setSize({ width: rect.width, height: rect.height });

    return () => resizeObserver.disconnect();
  }, [ref]);

  return size;
};
